import { useDeferredValue, useMemo, useState } from "react"
import { readQuestion, type Read } from "./reads"

const MAX = 8

/**
 * One quiet line under the composer, filled in as the reader types: what Nira reads in the question
 * (landing/reads.ts). Each thing lands once and stays while it is in the text; nothing underlines the
 * question itself.
 */
export function QuestionReads({ text }: { text: string }) {
  const deferred = useDeferredValue(text)
  const reads = useMemo(() => readQuestion(deferred), [deferred])
  const [all, setAll] = useState(false)
  if (!reads.length) return null
  const shown = all ? reads : reads.slice(0, MAX)
  const more = reads.length - shown.length
  return (
    <div className="nl-reads" aria-label="What Nira reads in your question">
      <span className="nl-reads-k" aria-hidden="true">Nira reads</span>
      <ul role="list">
        {shown.map((r) => <ReadChip key={r.key} read={r} />)}
        {more > 0 ? (
          <li className="nl-read more">
            <button type="button" onClick={() => setAll(true)} aria-label={`Show ${more} more`}>+{more} more</button>
          </li>
        ) : null}
      </ul>
    </div>
  )
}

function ReadChip({ read }: { read: Read }) {
  return (
    <li className={`nl-read ${read.kind}`} title={read.note ? `${read.label}: ${read.note}` : read.label}>
      <b>{read.label}</b>
      {read.note ? <span>{read.note}</span> : null}
    </li>
  )
}
